import * as InternetSettingsActions from './../actions/internet-settings.actions';

export interface InternetPasswordState {
  passwordState: {
    success: boolean;
    error: boolean;
  };
  modemSafetyState: {
    profile: any;
    updateError: boolean;
    updateSuccess: boolean;
  };
  sharedIpState: {
    success: boolean;
    error: boolean;
  };
  macIpAddressState: {
    macAddress: string;
    getSuccess: boolean;
    getError: boolean;
    updateSuccess: boolean;
    updateError: boolean;
    addSuccess: boolean;
    addError: boolean;
    deleteSuccess: boolean;
    deleteError: boolean;
    pending: boolean;
  };
  bizzGuestWifiState: {
    data: any;
    success: boolean;
    error: boolean;
  };
}

export const initialState: InternetPasswordState = {
  passwordState: { success: false, error: false },
  modemSafetyState: { profile: {}, updateError: false, updateSuccess: false },
  sharedIpState: { success: false, error: false },
  macIpAddressState: {
    macAddress: '',
    getSuccess: false,
    getError: false,
    addError: false,
    addSuccess: false,
    deleteError: false,
    deleteSuccess: false,
    updateError: false,
    updateSuccess: false,
    pending: false,
  },
  bizzGuestWifiState: { data: {}, success: false, error: false },
};

export const getInternetPasswordState = (state: InternetPasswordState) =>
  state.passwordState;
export const getModemSafetyState = (state: InternetPasswordState) =>
  state.modemSafetyState;
export const getSharedIpState = (state: InternetPasswordState) =>
  state.sharedIpState;
export const getMacIpAddressState = (state: InternetPasswordState) =>
  state.macIpAddressState;
export const getBizzGuestWifi = (state: InternetPasswordState) =>
  state.bizzGuestWifiState;

export function reducer(
  state: InternetPasswordState = initialState,
  action: InternetSettingsActions.Actions,
): InternetPasswordState {
  switch (action.type) {
    case InternetSettingsActions.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        passwordState: { success: true, error: false },
      };

    case InternetSettingsActions.UPDATE_PASSWORD_FAILED:
      return {
        ...state,
        passwordState: { success: false, error: true },
      };

    case InternetSettingsActions.GET_MODEM_SAFETY_SUCCESS:
      return {
        ...state,
        modemSafetyState: {
          profile: action.payload,
          updateError: state.modemSafetyState.updateError,
          updateSuccess: state.modemSafetyState.updateSuccess,
        },
      };

    case InternetSettingsActions.GET_MODEM_SAFETY_FAILURE:
      return {
        ...state,
        modemSafetyState: {
          profile: {},
          updateError: false,
          updateSuccess: false,
        },
      };

    case InternetSettingsActions.UPDATE_MODEM_SAFETY_SUCCESS:
      return {
        ...state,
        modemSafetyState: {
          profile: {
            ...state.modemSafetyState.profile,
            technicalProfile: action.payload,
          },
          updateError: false,
          updateSuccess: true,
        },
      };

    case InternetSettingsActions.UPDATE_MODEM_SAFETY_FAILURE:
      return {
        ...state,
        modemSafetyState: {
          profile: state.modemSafetyState.profile,
          updateError: true,
          updateSuccess: false,
        },
      };

    case InternetSettingsActions.UPDATE_SHARED_IP_SUCCESS:
      return {
        ...state,
        sharedIpState: {
          success: true,
          error: false,
        },
      };

    case InternetSettingsActions.UPDATE_SHARED_IP_FAILURE:
      return {
        ...state,
        sharedIpState: {
          success: false,
          error: true,
        },
      };

    case InternetSettingsActions.GET_WIFI_SSID_SUCCESS:
      return {
        ...state,
        bizzGuestWifiState: {
          data: action.payload,
          success: state.bizzGuestWifiState.success,
          error: state.bizzGuestWifiState.error,
        },
      };

    case InternetSettingsActions.GET_WIFI_SSID_FAILURE:
      return {
        ...state,
        bizzGuestWifiState: {
          data: {},
          success: false,
          error: false,
        },
      };

    case InternetSettingsActions.UPDATE_WIFI_SSID_SUCCESS:
      return {
        ...state,
        bizzGuestWifiState: {
          data: { ...state.bizzGuestWifiState.data, wifiSsid: action.payload },
          success: true,
          error: false,
        },
      };

    case InternetSettingsActions.UPDATE_WIFI_SSID_FAILURE:
      return {
        ...state,
        bizzGuestWifiState: {
          data: state.bizzGuestWifiState.data,
          success: false,
          error: true,
        },
      };

    case InternetSettingsActions.GET_MAC_IP_ADDRESS:
    case InternetSettingsActions.UPDATE_MAC_IP_ADDRESS:
    case InternetSettingsActions.ADD_MAC_IP_ADDRESS:
    case InternetSettingsActions.DELETE_MAC_IP_ADDRESS:
      return {
        ...state,
        macIpAddressState: {
          ...state.macIpAddressState,
          getSuccess: false,
          getError: false,
          addError: false,
          addSuccess: false,
          updateError: false,
          updateSuccess: false,
          deleteError: false,
          deleteSuccess: false,
          pending: true,
        },
      };

    case InternetSettingsActions.GET_MAC_IP_ADDRESS_SUCCESS:
      return {
        ...state,
        macIpAddressState: {
          ...state.macIpAddressState,
          macAddress: action.payload.fixedIpMacAddress,
          getSuccess: true,
          pending: false,
        },
      };

    case InternetSettingsActions.GET_MAC_IP_ADDRESS_FAILURE:
      return {
        ...state,
        macIpAddressState: {
          ...state.macIpAddressState,
          getError: true,
          pending: false,
        },
      };

    case InternetSettingsActions.UPDATE_MAC_IP_ADDRESS_SUCCESS:
      return {
        ...state,
        macIpAddressState: {
          ...state.macIpAddressState,
          updateSuccess: true,
          pending: false,
        },
      };

    case InternetSettingsActions.UPDATE_MAC_IP_ADDRESS_FAILURE:
      return {
        ...state,
        macIpAddressState: {
          ...state.macIpAddressState,
          updateError: true,
          pending: false,
        },
      };

    case InternetSettingsActions.ADD_MAC_IP_ADDRESS_SUCCESS:
      return {
        ...state,
        macIpAddressState: {
          ...state.macIpAddressState,
          addSuccess: true,
          pending: false,
        },
      };

    case InternetSettingsActions.ADD_MAC_IP_ADDRESS_FAILURE:
      return {
        ...state,
        macIpAddressState: {
          ...state.macIpAddressState,
          addError: true,
          pending: false,
        },
      };

    case InternetSettingsActions.DELETE_MAC_IP_ADDRESS_SUCCESS:
      return {
        ...state,
        macIpAddressState: {
          ...state.macIpAddressState,
          macAddress: '',
          deleteSuccess: true,
          pending: false,
        },
      };

    case InternetSettingsActions.DELETE_MAC_IP_ADDRESS_FAILURE:
      return {
        ...state,
        macIpAddressState: {
          ...state.macIpAddressState,
          deleteError: true,
          pending: false,
        },
      };

    default:
      return state;
  }
}
